
import React, { useState } from 'react'

/**
 * usePending returns a pending state and wrapped function.
 */

export default function usePending(fn) {
  const [pending, setPending] = useState(false)

  async function callback(e) {
    setPending(true)
    await fn(e)
    setPending(false)
  }

  return [pending, callback]
}